import React from 'react'
import { IconArrowsDiagonalMinimize2 } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'

export const VideoPlayerToggleButton = ({ toggleVideoMaximized }) => {
  return (
    <Button small onClick={toggleVideoMaximized}>
      <IconArrowsDiagonalMinimize2 /> Minimize
    </Button>
  )
}
